<template>
  <h1 class="sr-only">3 column card component</h1>
  <main class="main">
    <BaseCard v-for="car in cars" :key="car" :car="car" />
  </main>
</template>

<script>
import BaseCard from "./components/base/BaseCard.vue";
import carData from "./data/carData.json";

export default {
  name: "App",
  components: { BaseCard },
  computed: {
    cars: () => carData,
  },
};
</script>

<style lang="scss">
@use 'App';
</style>
